<template>
  <div>
    <v-col v-if="showAnimation" cols="12">
      <v-card max-width="3000" max-height="300" color="primary darken-1">
        <div style="height: 300px;">
          <loading-animation @loopComplete="loadAnimationComplete"></loading-animation>
        </div>
      </v-card>
    </v-col>
    <v-sheet v-else class="mx-auto elevation-0" max-width="1500" color="transparent">
      <div v-if="this.searchResult && this.results">
        <br/>
        <v-row v-if="this.alert">
          <v-col cols="12">
            <v-card color="primary dark" elevation="0" width="2000" height="80">
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <v-icon color="#FF7C55" left>
                        mdi-information-outline
                      </v-icon>
                      <span style="color: #FF7C55">
                          {{ 'Não há resultados para '}}
                          <strong>{{notFound.descricao}}</strong>
                          {{ ' no período pesquisado.'}}
                        </span>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="results.length === 0 && this.searchResult.type">
          <v-col cols="12">
            <v-card color="primary dark" elevation="0" width="2000" height="80">
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <v-icon color="#FF7C55" left>
                        mdi-information-outline
                      </v-icon>
                      <span style="color: #FF7C55">Não há resultados no período pesquisado.</span>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <v-slide-group class="pa-4" show-arrows>
        <template v-slot:next>
          <v-btn small fab elevation="0" color="primary darken-1">
            <v-icon x-large color="secondary lighten-1">mdi-chevron-right</v-icon>
          </v-btn>
        </template>
        <template v-slot:prev>
          <v-btn small fab elevation="0" color="primary darken-1">
            <v-icon x-large color="secondary lighten-1">mdi-chevron-left</v-icon>
          </v-btn>
        </template>
        <v-row class="align-center justify-center">
          <v-slide-item v-for="(item, index) in results" :key="index">
            <v-card
              v-if="item"
              color="primary dark"
              class="ma-4"
              max-height="235"
              max-width="271"
              style="border-radius: 6px"
              elevation="0"
            >
              <div class="">
                <v-card-title>
                  <v-icon color="secondary lighten-1" class="mb-2">
                    {{ item.icon }}
                  </v-icon>
                </v-card-title>
                <v-card-subtitle style="font-size: 16px" class="font-weight-bold white--text">{{ item.sensor.descricao }} | {{ item.operation.descricao }}</v-card-subtitle>
                <v-card-text>
                  <v-row class="white--text">
                    <v-col cols="12">
                      <strong class="display-1 font-weight-bold">{{ item.value }}
                        <span class="font-weight-thin" style="font-size: medium"> {{ item.unity }}</span>
                      </strong>
                    </v-col>
                    <v-col cols="12" class="mt-n5">
                      <v-icon small color="#A0A0A0" left>mdi-map-marker-circle</v-icon><span style="font-size: small; color: #A0A0A0">{{ item.station.nome }}</span>
                      <br/>
                      <v-icon small color="#A0A0A0" left>{{ iconType() }}</v-icon><span style="font-size: small; color: #A0A0A0">{{ item.date }}</span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </div>
              <v-btn
                :color="!rest(index) ? '#D96CBC' : '#339CB9'"
                block
                tile
                style="border-bottom-right-radius: 6px; border-bottom-left-radius: 6px; cursor: none; pointer-events: none"
              >
                <v-icon color="#212a35" left>{{ !rest(index) ? 'mdi-arrow-down' : 'mdi-arrow-up' }}</v-icon>
                <strong style="color:#212a35; font-size: small; text-transform: none">
                  {{ !rest(index) ? 'Menor ' + item.sensor.descricao + ' no período' : 'Maior ' + item.sensor.descricao + ' no período' }}
                </strong>
              </v-btn>
            </v-card>
          </v-slide-item>
        </v-row>
      </v-slide-group>
    </v-sheet>
  </div>
</template>

<script>
import moment from "moment";
import LoadingAnimation from "../common/LoadingAnimation";
export default {
  components: {LoadingAnimation},
  props:['searchResult'],
  name: "CardsDataSearchResult",
  data: () => ({
    filter: false,
    results: [],
    type: undefined,
    loading: true,
    showAnimation: false,
    alert: false,
    notFound: undefined,
  }),
  watch: {
    searchResult(){
      if(this.searchResult){
        this.initialize()
      }
    }
  },
  computed: {
    sensors(){
      return this.$store.getters.sensors
    },
    stations (){
      return this.$store.getters.stations
    },
    operations(){
      return this.$store.getters.operations
    },
  },
  created(){
    if(this.searchResult){
      this.initialize()
    }
  },
  methods:{
    iconType(){
      if(this.type === 'horario'){
        return 'mdi-update'
      } else if(this.type === 'diario'){
        return 'mdi-calendar'
      } else if(this.type === 'mensal'){
        return 'mdi-calendar-month'
      }
    },
    loadAnimationComplete(){
      this.showAnimation = this.loading;
    },
    async initialize(){
      this.loading = true
      //this.showAnimation = true
      const highlightsCards = [];
      this.results = []
      this.type = this.searchResult.type
      let reduced = this.searchResult.resultList.reduce((objetoFinal, objetoAtual) => {
        if (!objetoFinal[objetoAtual.sensorId]) objetoFinal[objetoAtual.sensorId] = []
        objetoFinal[objetoAtual.sensorId].push(objetoAtual);
        return objetoFinal
      }, {})
      let reducedSensors = []
      for (let index in reduced){ reducedSensors.push(index) }
      if(this.searchResult.sensors.length === 2 && reducedSensors.length === 1){
        for(let id in this.searchResult.sensors){
          const findSensor = this.searchResult.resultList.find((a) => a.sensorId === this.searchResult.sensors[id].codigo)
          if(findSensor) this.notFound = findSensor
        }
        this.notFound = this.searchResult.sensors.find((a) => a.codigo !== this.notFound.sensorId)
        this.alert = true
      } else { this.alert = false }
      let preResult = []
      for (let index in reduced){
        let obj = {
          min: Object.assign({}, this.minValue(reduced[index])),
          max: Object.assign({}, this.maxValue(reduced[index])),
        }
        preResult.push(obj)
      }
      for(let result in preResult){
        if(this.type === 'horario'){
          preResult[result].min.date = this.formatValue(preResult[result].min.datahora)
          preResult[result].max.date = this.formatValue(preResult[result].max.datahora)
        } else if(this.type === 'diario'){
          preResult[result].min.date = this.formatValue(preResult[result].min.data)
          preResult[result].max.date = this.formatValue(preResult[result].max.data)
        } else if(this.type === 'mensal'){
          preResult[result].min.date = this.formatValue(preResult[result].min.ano+'-'+preResult[result].min.mes)
          preResult[result].max.date = this.formatValue(preResult[result].max.ano+'-'+preResult[result].max.mes)
        }
        preResult[result].min.tag = 'min'
        preResult[result].max.tag = 'max'
        preResult[result].max.operation = this.operations.find((a) => a.codigo === preResult[result].min.operacaoId)
        preResult[result].min.operation = this.operations.find((a) => a.codigo === preResult[result].max.operacaoId)
        preResult[result].max.station = this.stations.find((a) => a.codigo === preResult[result].min.estacaoId)
        preResult[result].min.station = this.stations.find((a) => a.codigo === preResult[result].max.estacaoId)
        preResult[result].max.sensor = this.sensors.find((a) => a.codigo === preResult[result].min.sensorId)
        preResult[result].min.sensor = this.sensors.find((a) => a.codigo === preResult[result].max.sensorId)
        preResult[result].min.icon = this.mapIconBySensorId(preResult[result].min.sensorId)
        preResult[result].max.icon = this.mapIconBySensorId(preResult[result].max.sensorId)
        preResult[result].min.unity = this.mapUnitBySensorId(preResult[result].min.sensorId)
        preResult[result].max.unity = this.mapUnitBySensorId(preResult[result].max.sensorId)
        preResult[result].min.value = this.mapDecimalPlacesBySensorId(preResult[result].min.sensorId, preResult[result].min.valor)
        preResult[result].max.value = this.mapDecimalPlacesBySensorId(preResult[result].max.sensorId, preResult[result].max.valor)
        this.results.push(preResult[result].min)
        this.results.push(preResult[result].max)
        highlightsCards.push(preResult[result].min, preResult[result].max);
      }
      this.loading = false;
      this.$emit("highlightsCards", highlightsCards);
    },
    rest(index){
      return index % 2;
    },
    mapIconBySensorId(code){
      if(code === 1 || code === 3 || code === 4 || code === 5){
        return 'icon-infohidro-termometro'
      } else if(code === 2){
        return 'mdi-water-alert-outline'
      } else if(code === 6){
        return 'mdi-sun-wireless'
      } else if(code === 7){
        return 'mdi-weather-pouring'
      } else if(code === 8 || code === 9 || code === 10){
        return 'mdi-weather-windy'
      } else if(code === 15){
        return 'mdi-gauge'
      } else if(code === 18){
        return 'mdi-arrow-expand-vertical'
      } else if(code === 33){
        return 'mdi-waves'
      } else {
        return 'icon-infohidro-volume'
      }
    },
    mapDecimalPlacesBySensorId(code, value){
      if (code === 7) {
        return value.toFixed(1)
      } else if (code === 15) {
        return value.toFixed(1)
      } else if (code === "pressAtmReduzida") {
        return value.toFixed(1)
      } else if (code === 4) {
        return value.toFixed(1)
      } else if (code === 3) {
        return value.toFixed(1)
      } else if (code === 28 || code === 101) {
        return value.toFixed(1)
      } else if (code === 1) {
        return value.toFixed(1)
      } else if (code === 5) {
        return value.toFixed(1)
      } else if (code === 2) {
        return value.toFixed(0)
      } else if (code === 8) {
        return (value * 3.6).toFixed(1)
      } else if (code === 9) {
        return (value * 3.6).toFixed(1)
      } else if (code === 6) {
        return value.toFixed(0)
      } else if (code === 18) {
        return value.toFixed(3)
      } else if (code === 33) {
        return value.toFixed(2)
      } else if (code === 20) {
        return value.toFixed(2)
      } else if (code === 21 ||code === 180 ||code === 181) {
        return value.toFixed(3)
      } else if (code === 177) {
        return value.toFixed(2)
      } else if(code === 294){
        return value.toFixed(3)
      } else {
        return value;
      }
    },
    mapUnitBySensorId(code){
      if (code === 7) {
        return "mm"
      } else if (code === 10) {
        return "°"
      } else if (code === 15) {
        return "hPa"
      } else if (code === 3) {
        return "°C"
      } else if (code === 4) {
        return "°C"
      } else if (code === 1) {
        return "°C"
      } else if (code === 5) {
        return "°C"
      } else if (code === 2 || code === 187 || code === 188) {
        return "%"
      } else if (code === 9) {
        return "km/h"
      } else if (code === 6) {
        return "W/m²"
      } else if (code === 8) {
        return "km/h"
      } else if (code === 18) {
        return "m"
      } else if (code === 33) {
        return "m³/s"
      } else if (code === 20) {
        return "°C"
      } else if (code === 21) {
        return "mg/L"
      } else if (code === 177) {
        return "%"
      } else if (code === 294) {
        return "hm³"
      } else {
        return ""
      }
    },
    minValue(myarr){
      if(myarr){
        let al = myarr.length;
        let minimum = myarr[al-1];
        while (al--){
          if(myarr[al].valor <= minimum.valor){
            minimum = myarr[al]
          }
        }
        return minimum;
      }
    },
    maxValue(myarr){
      if(myarr) {
        let al = myarr.length;
        let maximum = myarr[al-1];
        while (al--) {
          if (myarr[al].valor >= maximum.valor) {
            maximum = myarr[al]
          }
        }
        return maximum;
      }
    },
    formatValue(val){
      let aux = ''
      if(this.type === 'horario'){
        aux = moment(val).tz("America/Sao_Paulo").format('DD/MM/YYYY HH:mm')
      } else if(this.type === 'diario'){
        aux = moment(val, 'YYYY-MM-DD').format('DD/MM/YYYY')
      } else if(this.type === 'mensal'){
        aux = moment(val, 'YYYY-MM').locale('pt-br').format('MM/YYYY')
      }
      return aux
    },
  },
}
</script>

<style scoped>
</style>
